import { SceneObjectType } from "~/types/SceneObjectType";

// TODO: CLASS_CONTEXTS
export const migratedContexts = new Set<SceneObjectType>([SceneObjectType.CAMERA, SceneObjectType.SPRITE]);
